export const baseUrl = '/wastestreams'
